export const environment = {
    production: false,
    isExternal: true,
    msalConfig: {
        auth: {
            clientId: 'b6870f9b-2354-4a32-83e4-3cb2e45009d6',
            authority: ""
        },
    },
    apiConfig: {
        scopes: ['openid profile offline_access b6870f9b-2354-4a32-83e4-3cb2e45009d6'],
        uri: 'https://pplfirstclassictrain.onmicrosoft.com/b6870f9b-2354-4a32-83e4-3cb2e45009d6/app.user',
    },
    b2cPolicies: {
        names: {
            signUpSignIn: 'B2C_1A_SIGNUP_SIGNIN',
        },
        authorities: {
            signUpSignIn: {
                authority:
                    'https://pplfirstclassictrain.b2clogin.com/pplfirstclassictrain.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN',
            }
        },
        authorityDomain: 'pplfirstclassictrain.b2clogin.com',
    },
    apiUrl: 'https://ngencl-api-trn.pplfirst.com/external-cl',
    mobileHealthUrl: 'https://www.mobilehealth.com/ny-cdpap-ppl-medical-screenings/',
    wotcUrl: 'https://sandbox.wotc.com/portal/public-partnerships-llc-sandbox/f8850?noStartDate=1',
    apimSubScriptionKey: 'b70aee9773324a609b2ad5e2f3801b4c',
    smartyEmbeddedKey: '215669382422753323',
    isSmartyEnabled: true,
    enableCaliforniaAddressValidation: true,
    restrictedMenus: ["process_codes", "service_codes", "participant_provider_rates", "authorizations", "timesheets"],
    requireAtleastOneUserFilter: true,
    goLiveDate: '2026-07-01',
    showGoLiveBanner: false
};